import { Flex, Text } from "styles/utility-components";

import type { SsoProvider } from "./SsoProviderCard";
import SsoProviderCard from "./SsoProviderCard";

type SsoProviderListProps = {
  providers: SsoProvider[];
};

export default function SsoProviderList({ providers }: SsoProviderListProps) {
  if (providers.length === 0) {
    return <Text description>No custom SSO providers configured yet.</Text>;
  }

  return (
    <Flex column gap={16}>
      {providers.map((provider) => (
        <SsoProviderCard key={provider.providerId} provider={provider} />
      ))}
    </Flex>
  );
}
